"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportActivities = exports.renderSportActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const faUser_1 = require("@fortawesome/pro-regular-svg-icons/faUser");
const react_i18next_1 = require("react-i18next");
const mapExertion = (t, exertion) => {
    const exertionDescriptions = t("sportActivity.exertionRange", {
        returnObjects: true
    });
    return exertionDescriptions[exertion] || "";
};
const renderSportActivity = (item) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [icon, setIcon] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const fetchIcon = async () => {
            const icon = await fetch(item.type.iconUrl);
            const text = await icon.text();
            setIcon(text);
        };
        if (!item.type.isCustom) {
            fetchIcon();
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ActivityItem, { isCustom: item.type.isCustom, children: [(0, jsx_runtime_1.jsx)("div", { children: item.type.isCustom ? ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faUser_1.faUser, color: "lightGrey-transparent" }, void 0)) : ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: icon || "" } }, void 0) }, void 0)) }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: item.type.name }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${item.duration} ${t("sportActivity.minutes")}` }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${t("sportActivity.exertion")} ${item.exertion || ""} - ${mapExertion(t, item.exertion)}` }, void 0)] }, void 0), item.note && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("sportActivity.remark") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: item.note }, void 0)] }, void 0))] }, void 0)] }, item.id));
};
exports.renderSportActivity = renderSportActivity;
const ActivityItem = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  padding: ${({ theme }) => theme.spacings.m};

  h4 {
    font-weight: 600;
  }

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: 0;
  }

  & > div:first-of-type {
    flex: 0;
    margin-right: ${({ theme }) => theme.spacings.m};

    & > div {
      align-items: center;
      background-color: ${({ theme, isCustom }) => isCustom ? "transparent" : theme.colors.greenLighten80};
      border-radius: 50%;
      display: flex;
      height: 35px;
      justify-content: center;
      width: 32px;

      & div,
      & svg {
        height: 16px;
        width: auto;
      }

      & svg {
        fill: ${({ theme }) => theme.colors.greenBase};
      }
    }
  }

  & > div:last-of-type {
    display: flex;
    flex-direction: column;

    & > div:first-of-type {
      & > h4,
      & > p {
        line-height: 1.5rem;
      }

      & > p {
        margin-top: ${({ theme }) => theme.spacings.xxs};
      }
    }

    & > div:last-of-type {
      margin-top: ${({ theme }) => theme.spacings.xxs};

      h4 {
        margin-bottom: ${({ theme }) => theme.spacings.xs};
      }
    }
  }
`;
const SportActivities = ({ sportActivities }) => {
    return (0, jsx_runtime_1.jsx)(Wrapper, { children: sportActivities.map(exports.renderSportActivity) }, void 0);
};
exports.SportActivities = SportActivities;
const Wrapper = styled_components_1.default.div `
  padding: ${({ theme }) => `${theme.spacings.m} 0 0`};

  & > div:not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding-top: 0;

    & > div:not(:first-of-type) {
      margin-top: 0;
    }

    & > div:first-of-type {
      border-top: none;
    }

    & > div {
      border-bottom: none;
    }
  }
`;
//# sourceMappingURL=SportActivities.js.map